import {
    Component,
    OnInit,
    Input,
    Output,
    EventEmitter,
    ViewChild,
} from '@angular/core';
import { SeStepperSideNavComponentType } from "./se-stepper-side-nav.models";
import { Subscription } from "rxjs";
import { Store, select } from '@ngrx/store';
import { RootState } from "../root-store/root.state";
import { selectActiveSeStepperSideComponentState } from "./redux/se-stepper-side-nav.selectors";
import { MatTabChangeEvent, MatTabGroup } from "@angular/material/tabs";

@Component({
    selector: 'se-stepper-side-nav',
    templateUrl: './se-stepper-side-nav.component.html',
    styleUrls: ['./se-stepper-side-nav.component.scss'],
})
export class SeStepperSideNavComponent implements OnInit {

    @Input() formData : any = {};
    @Output() isOpen : EventEmitter<boolean> = new EventEmitter<boolean>();
    @ViewChild('matStepperTabGroup') matTabs : MatTabGroup | undefined;

    activeSideComponents$ = this.store.pipe(select(selectActiveSeStepperSideComponentState));
    closed : boolean = false;
    hideContent : boolean = false;
    selectedTabIndex : number = 0;
    show : boolean = true;
    sideComponentType = SeStepperSideNavComponentType;
    subscriptions : Subscription[] = [];
    private handleTabContentVisibility : Map<boolean, (index : number) => void> = new Map<boolean, (index : number) => void>();

    constructor (private store : Store<RootState>) {
        this.handleTabContentVisibility.set(true, this.showTabContent);
        this.handleTabContentVisibility.set(false, this.hideTabContent);
    }

    ngOnInit () {
        this.isOpen.emit(!this.hideContent);
        if (this.closed) {
            this.unselectTabs();
        }

        if (this.selectedTabIndex === -1 && !this.closed) {
            this.selectFirstTab();
        }
    }

    private selectFirstTab () {
        this.selectedTabIndex = 0;
        this.hideContent = false;
    }

    private unselectTabs () {
        this.selectedTabIndex = -1;
        this.hideContent = true;
    }

    private showTabContent = (index : number) => {
        this.selectedTabIndex = index;
    };

    private hideTabContent = (_ : number) => {
        this.selectedTabIndex = -1;
    };

    onSelectedTabChange (showTabContent : MatTabChangeEvent) {
        this.handleTabContentVisibility.get(!this.hideContent)(showTabContent.index);
        setTimeout(() => {
            this.matTabs.realignInkBar(); // Serve altrimenti al primo avvio l'animazione non parte
        }, 0);
    }

    onClick (tabIndex : number) {  
        if (!!this.closed) {
            this.hideContent = false;
            this.selectedTabIndex = tabIndex;
            return;
        }

        if (this.selectedTabIndex === -1) {
            this.hideContent = false;
            this.selectedTabIndex = tabIndex;
            return;
        }

        if (this.selectedTabIndex === tabIndex) {
            this.hideContent = true;
            this.handleTabContentVisibility.get(!this.hideContent).apply(tabIndex);
            return;
        }
    }
}

